import React from 'react';
import * as PropTypes from 'prop-types';

import { Spacer } from './elements';

function Spa40(props) {
  return <Spacer className={props.className} />;
}

Spa40.propTypes = {
  className: PropTypes.string,
};

export default Spa40;
